export default "__VITE_ASSET__938840de__"